import queryString from 'query-string';
import useStewardshipFilter from '@/pages/events/useStewardshipFilter';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const stewardshipFilter = useStewardshipFilter();

  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          activityId: {
            $null: false
          },
          siteId: {
            $null: true
          },
          $or: stewardshipFilter,
          ...extra
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
